<template>
  <Form ref="form" :model="form" :rules="ruleValidate" label-position="left" :label-width="80">
    <FormItem label="用户名" prop="username">
      <Input v-model="form.username" placeholder="请输入用户名"></Input>
    </FormItem>
    <FormItem v-if="condition" label="密码" >
      <Input type="password" :style="{width:'calc(100% - 300px)'}" v-model="form.password" placeholder="请输入密码"></Input>
      <span style="color: red;padding-left: 8px">*不填默认是原来密码，新添是最新密码</span>
    </FormItem>
    <FormItem v-if="!condition" label="密码" prop="password">
      <Input type="password" v-model="form.password" placeholder="请输入密码"></Input>
    </FormItem>
    <FormItem label="状态">
      <RadioGroup v-model="form.status">
        <Radio :label="1"><span>正常</span></Radio>
        <Radio :label="2"><span>禁用</span></Radio>
      </RadioGroup>
    </FormItem>
    <FormItem>
      <Button type="primary" :loading="loading" @click="handleSubmit('form')">保存数据</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {

  props: {
    condition: {
      type: [Boolean, Number, String, Array],
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        //全部
        library_id: localStorage.getItem('libId'),
        user_type: 1,
        status: 1,//状态 1正常 2禁用
        //管理员
        username: '',//用户名
        password: null,//密码
        // 编辑、专家
        name: '',//姓名
        tel: '',//手机号
        //专家
        work: '',//工作单位
        professional:'',//职称
        academy:'',//所属院系
      },

      ruleValidate: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {type: 'string', min: 6, message: '小于6位', trigger: 'blur'}
        ],
      },
    }
  },
  methods: {
    /*****************************************************************
     * 表单验证
     * @param   {name}             要验证的表单名称
     *****************************************************************/
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          !this.condition ? this.addSubmit() : this.editSubmit()
        } else {
          this.loading = false
          this.$Message.error('请核对输入内容!');
        }
      })
    },

    /*****************************************************************
     * 添加数据
     *****************************************************************/
    addSubmit() {
      this.$httpsencrypt.post('api/contributeweb/v3/users/add', this.form).then(val => {
        this.$emit('operationState', true)
        this.loading = false
        this.$Message.success('添加成功!');
      }).catch(err => {
        this.loading = false
      })
    },

    /*****************************************************************
     *
     * 修改数据
     *
     *****************************************************************/
    editSubmit() {
      this.$set(this.form,'id',this.condition)
      this.$httpsencrypt.post('api/contributeweb/v3/users/edit', this.form).then(val => {
        this.$emit('operationState', true)
        this.loading = false;
        this.$Message.success('修改成功!');
      }).catch(err => {
        this.loading = false;
      })

    },

    /*****************************************************************
     *
     * 单条查询数据
     *
     *****************************************************************/
    selData() {
      this.loading = true
      let cond = {
        id:this.condition,
        library_id:localStorage.getItem('libId'),
        user_type:1,
      }
      this.$httpsencrypt.post('api/contributeweb/v3/users/info',cond).then(val => {
        this.form.username = val.data.username
        this.form.status = val.data.status
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },


  },
  mounted() {
    if (this.condition) this.selData()
  }
};
</script>
